import { jsPDF } from 'jspdf';

// Unicode PDF font (DejaVu Sans subset): √ − ≤ ≈ Δ ρ μ ‰ … instead of stripped Latin-1 helvetica
const FILES = { normal: '/fonts/DejaVuSans.ttf', bold: '/fonts/DejaVuSans-Bold.ttf' };
const B64 = {};
const toB64 = (buf) => { const u = new Uint8Array(buf); let s = ''; for (let i = 0; i < u.length; i += 0x8000) s += String.fromCharCode.apply(null, u.subarray(i, i + 0x8000)); return btoa(s); };
export const pdfFontReady = () => !!(B64.normal && B64.bold);

export async function loadPdfFont() {
  if (pdfFontReady()) return true;
  try {
    await Promise.all(Object.entries(FILES).map(async ([k, u]) => { const r = await fetch(u); if (!r.ok) throw new Error(u); B64[k] = toB64(await r.arrayBuffer()); }));
  } catch { return false; }
  return true;
}

const COVER = /[^\u0009\u000A\u000D\u0020-\u007E\u00A0-\u024F\u0370-\u03FF\u0400-\u045F\u2000-\u206F\u2070-\u209F\u20AC\u2100-\u215F\u2190-\u23FF\u2460-\u27BF]/g;
const LATIN1 = /[^\x00-\xFF\u20AC]/g;
const ASCII_MAP = [[/[–—]/g, '-'], [/[“”„]/g, '"'], [/[‘’]/g, "'"], [/−/g, '-'], [/≤/g, '<='], [/≥/g, '>='], [/≈/g, '~'], [/√/g, 'sqrt'], [/‰/g, ' promille'], [/Δ/g, 'd'], [/ρ/g, 'rho'], [/μ/g, 'µ']];
// text safe for the active PDF font (unicode when loaded, readable Latin-1 fallback otherwise)
export const pdfSafe = (s) => {
  const x = String(s ?? '');
  if (pdfFontReady()) return x.replace(COVER, '');
  return ASCII_MAP.reduce((v, [r, w]) => v.replace(r, w), x).replace(LATIN1, '');
};

jsPDF.API.events.push(['initialized', function init() {
  if (!pdfFontReady()) return;
  this.addFileToVFS('giss-sans.ttf', B64.normal);
  this.addFont('giss-sans.ttf', 'GissSans', 'normal');
  this.addFileToVFS('giss-sans-b.ttf', B64.bold);
  this.addFont('giss-sans-b.ttf', 'GissSans', 'bold');
  const orig = this.setFont.bind(this);
  this.setFont = (name, style = 'normal', weight) => {
    if (!name || /helvetica|times|courier/i.test(name)) return orig('GissSans', /bold/i.test(String(style)) ? 'bold' : 'normal');
    return orig(name, style, weight);
  };
  this.setFont('helvetica', 'normal');
}]);
